package uz.ferro.erp.feature.customer.model

import kotlinx.serialization.Serializable

@Serializable
class CustomerDto {
    val id: String? = null
    val name: String? = null
    val groupId: Long? = null
    val phone1: String? = null
    val phone2: String? = null
    val balance: Double? = null
    val addresses: List<CustomerAddressDto>? = null
}